/** @fileoverview Reads all connected system types visible to the current user in a tenant. */

import { json } from './platformAuth';

export type UserSystemCode = string;

type UserSystemRecord = {
  user_system_id: string;
  name: string;
  system: UserSystemCode;
  environment?: string | null;
  ping_status?: string | null;
  system_secrets?: { company_id?: string } | null;
};

export type ConnectedSystem = {
  id: string;
  name: string;
  code: UserSystemCode;
  environment?: string;
  pingStatus?: string;
  companyId?: string;
};

/** Loads display-safe fields for every system type; credentials stay out of the UI. */
export async function listConnectedSystems(tenantId: string, signal?: AbortSignal) {
  const records = await json<UserSystemRecord[]>('/app/system/user-system', tenantId, { signal });

  return records.flatMap((system) =>
    system.user_system_id && system.name && system.system
      ? [
          {
            id: system.user_system_id,
            name: system.name,
            code: system.system,
            ...(system.environment ? { environment: system.environment } : {}),
            ...(system.ping_status ? { pingStatus: system.ping_status } : {}),
            ...(system.system_secrets?.company_id
              ? { companyId: system.system_secrets.company_id }
              : {}),
          },
        ]
      : []
  );
}
